/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Card, Col, Form, Select, TimePicker } from 'antd';

import { createShowField } from '../../../../Components/ResourceFieldLayout/shouldRenderTaskField';

import DriverVehicleSelector from './DriverVehicleSelector';

function FormTransportFieldsComponent({
  fieldsPermissions,
  transportOptions,
  driverOptions,
  vehicleOptions,
  isTaskReadOnly,
  stages,
  task,
  isEditing,
  onCreateDriver,
  fieldLayout,
  roleId,
  fieldNameFilter,
  hideSectionCard,
}) {
  const showField = createShowField(fieldsPermissions, fieldLayout, roleId, fieldNameFilter);
  const [driverListOptions, setDriverListOptions] = useState([]);
  const [vehicleListOptions, setVehicleListOptions] = useState([]);
  const [selectedTransportCompanyId, setSelectedTransportCompanyId] = useState(
    task?.transportCompany?.id ?? null
  );

  const handleTransportCompanyChange = (transportCompanyId) => {
    const transportCompanyIdNumber = Number(transportCompanyId);
    setSelectedTransportCompanyId(
      Number.isNaN(transportCompanyIdNumber) ? null : transportCompanyIdNumber
    );

    const selectedTransportCompany = transportOptions.find(
      (company) => company.id === transportCompanyIdNumber
    );

    if (selectedTransportCompany) {
      // Mapear motoristas da empresa de transporte
      if (
        selectedTransportCompany.driverList &&
        Array.isArray(selectedTransportCompany.driverList)
      ) {
        const driverOptionsIds = driverOptions.map(({ userId }) => userId);

        const transportDriverOptions = selectedTransportCompany.driverList
          .filter(({ id }) => driverOptionsIds.includes(id))
          .map((item) => {
            const driverObj = driverOptions.find(({ id }) => id === item.id);

            return {
              ...driverObj,
              label: driverObj.name,
              value: driverObj.id,
            };
          });

        setDriverListOptions(transportDriverOptions);
      } else {
        setDriverListOptions([]);
      }

      // Mapear veículos da empresa de transporte
      if (
        selectedTransportCompany.vehicleList &&
        Array.isArray(selectedTransportCompany.vehicleList)
      ) {
        const vehicleOptionsIds = vehicleOptions.map(({ userId }) => userId);
        const transportVehicleOptions = selectedTransportCompany.vehicleList
          .filter(({ userId }) => vehicleOptionsIds.includes(userId))
          .map((item) => ({
            ...item,
            label: `${item.licensePlate} - ${item.type.name} - ${item.capacity} lugares`,
            value: item.id,
          }));

        setVehicleListOptions(transportVehicleOptions);
      } else {
        setVehicleListOptions([]);
      }
    } else {
      setDriverListOptions([]);
      setVehicleListOptions([]);
    }
  };

  useEffect(() => {
    if (task?.transportCompany) {
      handleTransportCompanyChange(task.transportCompany.id);
    }
  }, [task?.transportCompany, driverOptions, vehicleOptions]);

  const isFieldDisabled = (fieldName) =>
    task?.stage?.id === 5 ||
    fieldsPermissions?.[fieldName]?.access !== 2 ||
    isTaskReadOnly ||
    !isEditing;

  const inner = (
    <>
      {showField('TransportCompany') && (
        <Col span={24}>
          <Form.Item
            label="Empresa Transporte"
            name="transportCompany"
            rules={[
              {
                required: fieldsPermissions?.TransportCompany.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
            getValueFromEvent={(_, object) => {
              if (!object) return null;

              return {
                ...object,
                name: object.label,
                id: object.value,
              };
            }}
          >
            <Select
              options={transportOptions}
              onChange={(value) => handleTransportCompanyChange(value)}
              allowClear
              placeholder="o campo está vazio"
              optionFilterProp="label"
              showSearch
              dropdownStyle={{ borderRadius: 16 }}
              disabled={isFieldDisabled('TransportCompany')}
            />
          </Form.Item>
        </Col>
      )}

      {showField('DriverList') && (
        <Col span={24}>
          <Form.Item
            label="Veículos e Motoristas"
            name="driverList"
            rules={[
              {
                required: fieldsPermissions?.DriverList.isRequired,
                message: 'Campo obrigatório!',
              },
              {
                validator: (_, value) => {
                  if (fieldsPermissions?.DriverList.isRequired) {
                    // Verifica se há pelo menos um motorista válido (com userId)
                    const validDrivers =
                      value?.filter(
                        (driver) => driver?.userId !== null && driver?.userId !== undefined
                      ) || [];
                    if (validDrivers.length === 0) {
                      return Promise.reject(new Error('Selecione pelo menos um motorista'));
                    }
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <DriverVehicleSelector
              driverListOptions={driverListOptions}
              vehicleListOptions={vehicleListOptions}
              stages={stages}
              fieldsPermissions={fieldsPermissions}
              isTaskReadOnly={isTaskReadOnly}
              isEditing={isEditing}
              task={task}
              transportCompanyId={selectedTransportCompanyId}
              onCreateDriver={onCreateDriver}
            />
          </Form.Item>
        </Col>
      )}

      {showField('BoardingHour') && (
        <Col span={24}>
          <Form.Item
            name="boardingHour"
            label="Horário de Embarque"
            rules={[
              {
                required: fieldsPermissions?.BoardingHour.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <TimePicker
              format="HH:mm"
              style={{ borderRadius: 16 }}
              disabled={isFieldDisabled('BoardingHour')}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}

      {showField('ArrivalHour') && (
        <Col span={24}>
          <Form.Item
            name="arrivalHour"
            label="Previsão de Chegada"
            rules={[
              {
                required: fieldsPermissions?.ArrivalHour.isRequired,
                message: 'Campo obrigatório',
              },
            ]}
          >
            <TimePicker
              format="HH:mm"
              style={{ borderRadius: 16 }}
              disabled={isFieldDisabled('ArrivalHour')}
              placeholder="o campo está vazio"
            />
          </Form.Item>
        </Col>
      )}
    </>
  );

  if (hideSectionCard) {
    return inner;
  }

  return (
    <Col span={24}>
      <Card title="Transporte" bordered={false} className="task-form-section-card">
        {inner}
      </Card>
    </Col>
  );
}

export default FormTransportFieldsComponent;
